<template>
  <div class="item">
    <div class="item_title d-flex align-center">
      <span class="flex-grow-1">
       {{ label }}
      </span>
      <ImageCarousel
        v-if="needImageDomain"
        :need-api-domain="needImageDomain"
        :images="images"
        :pdf="pdf"
        icon-filled
        :disabled="!images || !images.length"
      />
      <PdfDocumentCreate
        v-if="needImageDomain"
        :items="itemsDoc"
        min-button
        :disabled="!images || !images.length"
        class="ml-2"
      />
      <v-btn v-if="editReady" icon @click="to ? null : dialog = true" :to="to">
        <BaseIcon :icon="buttonIcon === 'edit' ? 'button-edit' : 'button-show'" color="#277faf"/>
      </v-btn>
      <v-dialog width="600" v-model="dialog">
        <div class="rel">
          <v-btn icon absolute top right @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <slot name="edit_block"></slot>
        </div>
      </v-dialog>
    </div>
    <div class="item_data">
      <div
        v-for="(d, dt) in data"
        :key="'data_' + dt"
        class="d-flex justify-space-between align-center"
      >
        <span v-if="d.name" class="text"> {{ d.name }}: </span>
        <span class="date">{{ d.value || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCarousel from '../../ImageCarousel'
import PdfDocumentCreate from "components/pdf/pdfDocument/PdfDocumentCreate";

export default {
  name: 'InnerCardInfo',
  components: {PdfDocumentCreate, ImageCarousel},
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
    files: {
      type: Array,
      default: () => {
        return []
      },
    },
    label: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
    needImageDomain: Boolean,
    pdf: Boolean,
    to: {
      type: [String, Object],
      default: null,
    }, 
    buttonIcon: {
      type: String,
      // 'edit', 'show'
      default: 'edit',
    },
    editReady: Boolean
  },
  computed: {
    itemsDoc() {
      let result = []
      result.push({text: this.label})
      if (this.images && this.images.length) {
        if (typeof this.images === 'object')
          for (let i in this.images)
            if (typeof this.images[i] === 'string') {
              if (this.images[i].split('.')[1] === 'pdf')
                result.push({doc: this.images[i]})
              else result.push({image: this.images[i]})
            }
        else result.push({image: this.images})
      }
      return result
    }
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    closeDialog() {
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">
.rel {
  position: relative;
  :deep() .template__main {
    max-width: none !important;
  }
}
.item {
  &_title {
    border: 1px solid #dbdbdb;
    padding: 8px 10px;
    color: #2c2c2c;
    font-size: 16px;
    font-weight: bold;
  }

  &_data {
    padding: 10px;
    font-weight: normal;
    font-size: 14px;

    .text {
      color: #92909c;
    }

    .date {
      color: #2c2c2c;
    }
  }
}
</style>
